export const INSTAGRAM_LINK = 'https://www.instagram.com/';
